import { Button, Checkbox, FormControlLabel, Grid, Radio, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Add } from '@mui/icons-material';
import { Fieldset } from '../../../../../../shared/ui/form/fieldset/FieldsetContainer';
import { useThirdStageVm } from './useThirdStage.vm';
import { Divider } from '../../../CaseDraft.styled';
import CloseIcon from '@mui/icons-material/Close';
import { InputController } from '../../../../../../shared/ui/form/inputController/InputController';
import { Input } from '../../../../../../shared/ui/form/input/Input';
import { DateInput } from '../../../../../../shared/ui/form/date/Date';
import {
  IInputControllerThirdStage,
  IIntervention,
  ISteroidogenesisInhibitor,
  ISteroidogenesisInhibitorCortisol,
  IThirdStageValuesCushingV2,
  ITreatment
} from './ThirdStage.types';
import { CheckboxesGroup } from '../../../../../../shared/ui/form/checkboxesGroup/CheckboxesGroup';
import {
  complicationsOfSurgicalProceduresCheckboxesConfig,
  neurosurgicalTreatmentOptions,
  otherComplicationsCheckboxesConfig,
  qualificationCheckboxesConfig,
  supportTreatmentCheckboxesConfig,
  tolerationCheckboxesConfig,
  tolerationOptions,
  treatmentBeforeOperationPasireotidesDoseOptions
} from './ThirdStage.helper';
import { SimpleUrinaryIncontinenceLabel } from './ThirdStage.styled';
import { SelectCustom } from '../../../../../../shared/ui/form/select/Select';

import { RadioGroupStyled } from '../../common/fourthStage/FourthStage.styled';
import { ButtonsActions } from '../../common/buttonsActions/ButtonsActions';
import { checkEmptyNumber, radioValueOptional } from '../../../CaseDraft.helper';

import { Label } from '../../../../../../shared/ui/form/label/Label';
import { MultipleSelect } from '../../../../../../shared/ui/form/multipleSelect/MultipleSelect';
import { FormikErrors } from 'formik';
import { useParams } from 'react-router-dom';
export const ThirdStage = observer(() => {
  const {
    mainTypeOptions,
    handleChangeCheckboxes,
    setActive,
    inputControllerElements,
    formik,
    handleSave,
    handleAddTreatment,
    handleDeleteTreatment,
    handleAddSteroidogenesisInhibitor,
    handleDeleteTreatmentBeforeOperationInhibitor,
    handleAddSupportTreatment,
    handleDeleteSupportTreatment,
    handleAddOperation,
    handleDeleteOperation,
    handleAddSteroidogenesisInhibitorArray,
    handleDeleteSteroidogenesisInhibitorArray,
    handleDeleteSteroidogenesisInhibitorDzm,
    handleAddSteroidogenesisInhibitorDzm,
    handleAddSteroidogenesisInhibitorSaliva,
    handleDeleteSteroidogenesisInhibitorSaliva,
    handleAddSteroidogenesisInhibitorSerum,
    handleDeleteSteroidogenesisInhibitorSerum,
    handleDraftSave,
    activeFieldset,
    handleResetFieldset,
    setOption
  } = useThirdStageVm();
  const params = useParams();

  const isCushing = params && params?.type?.includes('cushing') && params?.version?.includes('v2');
  return (
    <Grid container justifyContent={'space-between'}>
      <Fieldset legend={'Leczenie z wyboru, które zastosowano u pacjenta'}>
        <Grid container mt={3}>
          {formik.values.treatmentOfChoivePatient.map((treatment, index) => (
            <Grid
              key={index}
              item
              xs={12}
              mt={1}
              mb={1}
              gap={2}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <span>{index + 1}</span>
              <Grid item xs={4}>
                <DateInput
                  label={'Data'}
                  required={false}
                  views={['year', 'month']}
                  openTo={'year'}
                  name={`treatmentOfChoivePatient[${index}].date`}
                  inputFormat={'mm.yyyy'}
                  value={formik.values.treatmentOfChoivePatient[index].date}
                  error={
                    Array.isArray(formik.touched.treatmentOfChoivePatient) &&
                    formik.touched.treatmentOfChoivePatient[index]?.date &&
                    Array.isArray(formik.errors.treatmentOfChoivePatient) &&
                    Boolean((formik.errors.treatmentOfChoivePatient[index] as FormikErrors<ITreatment>)?.date)
                  }
                  onBlur={() => formik.setFieldTouched(`treatmentOfChoivePatient[${index}].date`, true)}
                  onChange={e => formik.setFieldValue(`treatmentOfChoivePatient[${index}].date`, e)}
                />
              </Grid>
              <Grid item xs={7}>
                <Input
                  InputLabelProps={{ shrink: true }}
                  fullWidth={true}
                  required={false}
                  name={`treatmentOfChoivePatient[${index}].treatment`}
                  label={'Leczenie'}
                  type={'text'}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.treatmentOfChoivePatient[index].treatment}
                  error={
                    Array.isArray(formik.touched.treatmentOfChoivePatient) &&
                    formik.touched.treatmentOfChoivePatient[index]?.treatment &&
                    Array.isArray(formik.errors.treatmentOfChoivePatient) &&
                    Boolean((formik.errors.treatmentOfChoivePatient[index] as FormikErrors<ITreatment>)?.treatment)
                  }
                />
              </Grid>
              <CloseIcon sx={{ cursor: 'pointer' }} color={'primary'} onClick={() => handleDeleteTreatment(index)} />
            </Grid>
          ))}

          <Grid item xs={12} mt={2}>
            <Button startIcon={<Add />} variant="contained" color={'primary'} onClick={handleAddTreatment}>
              DODAJ
            </Button>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset legend={'Leczenie przygotowawcze przed zabiegiem operacyjnym (jeśli dotyczy)'}>
        <Grid container mt={3}>
          <Grid item xs={12} mb={2}>
            <FormControlLabel
              control={
                <Checkbox
                  name={'treatmentBeforeOperationInhibitorsCheckbox'}
                  checked={formik.values.treatmentBeforeOperationInhibitorsCheckbox}
                  onChange={formik.handleChange}
                />
              }
              label="Inhibitor steroidogenezy"
            />
          </Grid>

          <Grid container display={'flex'} alignItems={'center'} justifyContent={'center'} gap={2}>
            {formik.values.treatmentBeforeOperationInhibitors.map((treatment, index) => (
              <Grid gap={2} display={'flex'} alignItems={'center'} justifyContent={'center'} key={index}>
                <span>{index + 1}</span>

                <Grid item xs={2.5} pr={1}>
                  <SelectCustom
                    error={
                      Array.isArray(formik.touched.treatmentBeforeOperationInhibitors) &&
                      formik.touched.treatmentBeforeOperationInhibitors[index]?.type &&
                      Array.isArray(formik.errors.treatmentBeforeOperationInhibitors) &&
                      Boolean(
                        (
                          formik.errors.treatmentBeforeOperationInhibitors[
                            index
                          ] as FormikErrors<ISteroidogenesisInhibitor>
                        )?.type
                      )
                    }
                    disabled={!formik.values.treatmentBeforeOperationInhibitorsCheckbox}
                    name={`treatmentBeforeOperationInhibitors[${index}].type`}
                    placeholder={'jaki?'}
                    label={'Jaki?'}
                    onChange={e =>
                      formik.setFieldValue(`treatmentBeforeOperationInhibitors[${index}].type`, e.target.value)
                    }
                    value={formik.values.treatmentBeforeOperationInhibitors[index].type as string}
                    options={mainTypeOptions}
                  />
                </Grid>
                <Grid item xs={2.5} pr={1}>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    disabled={!formik.values.treatmentBeforeOperationInhibitorsCheckbox}
                    error={
                      Array.isArray(formik.touched.treatmentBeforeOperationInhibitors) &&
                      formik.touched.treatmentBeforeOperationInhibitors[index]?.dose &&
                      Array.isArray(formik.errors.treatmentBeforeOperationInhibitors) &&
                      Boolean(
                        (
                          formik.errors.treatmentBeforeOperationInhibitors[
                            index
                          ] as FormikErrors<ISteroidogenesisInhibitor>
                        )?.dose
                      )
                    }
                    name={`treatmentBeforeOperationInhibitors[${index}].dose`}
                    type={'number'}
                    onChange={formik.handleChange}
                    value={checkEmptyNumber(formik.values.treatmentBeforeOperationInhibitors[index].dose as number)}
                    label={'Dawka'}
                  />
                </Grid>
                <Grid item xs={3} pr={1}>
                  <DateInput
                    disabled={!formik.values.treatmentBeforeOperationInhibitorsCheckbox}
                    error={
                      Array.isArray(formik.touched.treatmentBeforeOperationInhibitors) &&
                      formik.touched.treatmentBeforeOperationInhibitors[index]?.dateStart &&
                      Array.isArray(formik.errors.treatmentBeforeOperationInhibitors) &&
                      Boolean(
                        (
                          formik.errors.treatmentBeforeOperationInhibitors[
                            index
                          ] as FormikErrors<ISteroidogenesisInhibitor>
                        )?.dateStart
                      )
                    }
                    label={'stosowanie - OD'}
                    required={false}
                    views={['year', 'month']}
                    openTo={'year'}
                    name={`treatmentBeforeOperationInhibitors[${index}].dateStart`}
                    inputFormat={'mm.yyyy'}
                    value={formik.values.treatmentBeforeOperationInhibitors[index].dateStart}
                    onBlur={() =>
                      formik.setFieldTouched(`treatmentBeforeOperationInhibitors[${index}].dateStart`, true)
                    }
                    onChange={e => formik.setFieldValue(`treatmentBeforeOperationInhibitors[${index}].dateStart`, e)}
                  />
                </Grid>
                <Grid item xs={3} pr={1}>
                  <DateInput
                    disabled={!formik.values.treatmentBeforeOperationInhibitorsCheckbox}
                    error={
                      Array.isArray(formik.touched.treatmentBeforeOperationInhibitors) &&
                      formik.touched.treatmentBeforeOperationInhibitors[index]?.dateEnd &&
                      Array.isArray(formik.errors.treatmentBeforeOperationInhibitors) &&
                      Boolean(
                        (
                          formik.errors.treatmentBeforeOperationInhibitors[
                            index
                          ] as FormikErrors<ISteroidogenesisInhibitor>
                        )?.dateEnd
                      )
                    }
                    label={'stosowanie - DO'}
                    required={false}
                    views={['year', 'month']}
                    openTo={'year'}
                    name={`treatmentBeforeOperationInhibitors[${index}].dateEnd`}
                    inputFormat={'mm.yyyy'}
                    value={formik.values.treatmentBeforeOperationInhibitors[index].dateEnd}
                    isStill={true}
                    onBlur={() => formik.setFieldTouched(`treatmentBeforeOperationInhibitors[${index}].dateEnd`, true)}
                    onChange={e => formik.setFieldValue(`treatmentBeforeOperationInhibitors[${index}].dateEnd`, e)}
                  />
                </Grid>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  color={'primary'}
                  onClick={() => handleDeleteTreatmentBeforeOperationInhibitor(index)}
                />
              </Grid>
            ))}
          </Grid>
          <Grid mt={2}>
            <Button
              disabled={!formik.values.treatmentBeforeOperationInhibitorsCheckbox}
              startIcon={<Add />}
              variant="contained"
              color={'primary'}
              onClick={handleAddSteroidogenesisInhibitor}
            >
              DODAJ
            </Button>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset legend={'Zabiegi operacyjne'}>
        <Grid container mt={3}>
          {formik.values.operations.map((el, index) => (
            <Grid gap={2} display={'flex'} flexDirection={'column'} item xs={12} key={index}>
              <Grid item xs={12} display={'flex'} gap={2} alignItems={'center'} justifyContent={'center'} mt={1}>
                <span>{index + 1}</span>

                <Grid item xs={6}>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    fullWidth={true}
                    required={false}
                    name={`operations[${index}].type`}
                    label={'Rodzaj zabiegu'}
                    type={'text'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.operations[index].type}
                    error={
                      Array.isArray(formik.touched.operations) &&
                      formik.touched.operations[index]?.type &&
                      Array.isArray(formik.errors.operations) &&
                      Boolean((formik.errors.operations[index] as FormikErrors<IIntervention>)?.type)
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <DateInput
                    label={'Data'}
                    required={false}
                    views={['year', 'month']}
                    openTo={'year'}
                    name={`operations[${index}].date`}
                    inputFormat={'mm.yyyy'}
                    value={formik.values.operations[index].date}
                    error={
                      Array.isArray(formik.touched.operations) &&
                      formik.touched.operations[index]?.date &&
                      Array.isArray(formik.errors.operations) &&
                      Boolean((formik.errors.operations[index] as FormikErrors<IIntervention>)?.date)
                    }
                    onBlur={() => formik.setFieldTouched(`operations[${index}].date`, true)}
                    onChange={async e => await formik.setFieldValue(`operations[${index}].date`, e)}
                  />
                </Grid>
                <CloseIcon sx={{ cursor: 'pointer' }} color={'primary'} onClick={() => handleDeleteOperation(index)} />
              </Grid>
              <Grid
                item
                xs={12}
                mt={1}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'flex-start'}
                justifyItems={'center'}
                justifyContent={'flex-start'}
              >
                <Label>W PRZYPADKU GUZA PRZYSADKI:</Label>
                <RadioGroupStyled
                  row={true}
                  name={`operations[${index}].pituaryTumor`}
                  value={formik.values.operations[index].pituaryTumor}
                >
                  <FormControlLabel
                    onChange={formik.handleChange}
                    value={'dostęp przezklinowy'}
                    control={
                      <Radio
                        color={
                          Array.isArray(formik.touched.operations) &&
                          formik.touched.operations[index]?.pituaryTumor &&
                          Array.isArray(formik.errors.operations) &&
                          Boolean((formik.errors.operations[index] as FormikErrors<IIntervention>)?.pituaryTumor)
                            ? 'error'
                            : 'default'
                        }
                      />
                    }
                    label="dostęp przezklinowy"
                  />
                  <FormControlLabel
                    onChange={formik.handleChange}
                    value={'dostęp przezczaszkowy (kraniotomia)'}
                    control={
                      <Radio
                        color={
                          Array.isArray(formik.touched.operations) &&
                          formik.touched.operations[index]?.pituaryTumor &&
                          Array.isArray(formik.errors.operations) &&
                          Boolean((formik.errors.operations[index] as FormikErrors<IIntervention>)?.pituaryTumor)
                            ? 'error'
                            : 'default'
                        }
                      />
                    }
                    label="dostęp przezczaszkowy (kraniotomia)"
                  />
                </RadioGroupStyled>
              </Grid>
            </Grid>
          ))}

          <Grid mt={2}>
            <Button startIcon={<Add />} variant="contained" color={'primary'} onClick={handleAddOperation}>
              DODAJ
            </Button>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset legend={'Subnormalne stężenie kortyzolu w surowicy w okresie bezpośrednio po operacji (< 2,0 μg/dl)'}>
        <Grid container mt={3}>
          <Grid
            item
            xs={12}
            mb={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <RadioGroupStyled row={true} name={'subnormalCortisolLevels'} value={formik.values.subnormalCortisolLevels}>
              <FormControlLabel
                onChange={formik.handleChange}
                value={'Tak'}
                control={
                  <Radio
                    onClick={() =>
                      formik.setFieldValue(
                        'subnormalCortisolLevels',
                        radioValueOptional(formik.values.subnormalCortisolLevels, 'Tak')
                      )
                    }
                  />
                }
                label="Tak"
              />
              <FormControlLabel
                onChange={formik.handleChange}
                value={'Nie'}
                control={
                  <Radio
                    onClick={() =>
                      formik.setFieldValue(
                        'subnormalCortisolLevels',
                        radioValueOptional(formik.values.subnormalCortisolLevels, 'Nie')
                      )
                    }
                  />
                }
                label="Nie"
              />
            </RadioGroupStyled>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset
        legend={'Konieczność leczenia substytucyjnego hydrokortyzonem'}
        keyFieldset={'valid-fieldset-1'}
        activeKey={activeFieldset}
        handleReset={handleResetFieldset}
      >
        <Grid container mt={3}>
          <Grid
            item
            xs={12}
            mb={1}
            display={'flex'}
            flexDirection={'column'}
            justifyItems={'flex-start'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <RadioGroupStyled row={true} name={'hydrocortisolTreatment'} value={formik.values.hydrocortisolTreatment}>
              <Grid
                container
                width={'100%'}
                display={'flex'}
                flexDirection={'row'}
                justifyItems={'flex-start'}
                alignItems={'center'}
              >
                <Grid item xs={2}>
                  <FormControlLabel
                    onChange={formik.handleChange}
                    value={'Tak'}
                    control={
                      <Radio
                        onClick={() =>
                          formik.setFieldValue(
                            'hydrocortisolTreatment',
                            radioValueOptional(formik.values.hydrocortisolTreatment, 'Tak')
                          )
                        }
                      />
                    }
                    label="Tak"
                  />
                </Grid>
                <Grid item xs={5} pr={1}>
                  <DateInput
                    disabled={formik.values.hydrocortisolTreatment !== 'Tak'}
                    label={'OD'}
                    required={false}
                    views={['year', 'month']}
                    openTo={'year'}
                    name={'hydrocortisolTreatmentDateStart'}
                    inputFormat={'mm.yyyy'}
                    value={formik.values.hydrocortisolTreatmentDateStart}
                    onBlur={() => formik.setFieldTouched('hydrocortisolTreatmentDateStart', true)}
                    onChange={e => formik.setFieldValue('hydrocortisolTreatmentDateStart', e)}
                  />
                </Grid>
                <Grid item xs={5}>
                  <DateInput
                    disabled={formik.values.hydrocortisolTreatment !== 'Tak'}
                    label={'DO'}
                    required={false}
                    views={['year', 'month']}
                    openTo={'year'}
                    name={'hydrocortisolTreatmentDateEnd'}
                    inputFormat={'mm.yyyy'}
                    value={formik.values.hydrocortisolTreatmentDateEnd}
                    error={Boolean(formik.errors.hydrocortisolTreatmentDateEnd)}
                    onBlur={() => formik.setFieldTouched('hydrocortisolTreatmentDateEnd', true)}
                    onChange={e => formik.setFieldValue('hydrocortisolTreatmentDateEnd', e)}
                  />
                </Grid>
              </Grid>
              <FormControlLabel
                onChange={formik.handleChange}
                value={'Nie'}
                control={
                  <Radio
                    onClick={() =>
                      formik.setFieldValue(
                        'hydrocortisolTreatment',
                        radioValueOptional(formik.values.hydrocortisolTreatment, 'Nie')
                      )
                    }
                  />
                }
                label="Nie"
              />
            </RadioGroupStyled>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset legend={'Powikłania zabiegów operacyjnych (neurochirurgicznych w przypadku ch. Cushinga)'}>
        <Grid container mt={3}>
          <Grid
            item
            xs={12}
            mb={1}
            gap={2}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
          >
            <SimpleUrinaryIncontinenceLabel>MOCZÓWKA PROSTA</SimpleUrinaryIncontinenceLabel>
            <RadioGroupStyled
              row={true}
              name={'complicationsOfSurgicalProcedures'}
              value={formik.values.complicationsOfSurgicalProcedures}
            >
              <FormControlLabel
                onChange={formik.handleChange}
                value={'Trwała'}
                control={
                  <Radio
                    onClick={() =>
                      formik.setFieldValue(
                        'complicationsOfSurgicalProcedures',
                        radioValueOptional(formik.values.complicationsOfSurgicalProcedures, 'Trwała')
                      )
                    }
                  />
                }
                label="Trwała"
              />
              <FormControlLabel
                onChange={formik.handleChange}
                value={'Przemijająca'}
                control={
                  <Radio
                    onClick={() =>
                      formik.setFieldValue(
                        'complicationsOfSurgicalProcedures',
                        radioValueOptional(formik.values.complicationsOfSurgicalProcedures, 'Przemijająca')
                      )
                    }
                  />
                }
                label="Przemijająca"
              />
            </RadioGroupStyled>
          </Grid>
          <Grid item xs={12} mt={1}>
            <CheckboxesGroup<IThirdStageValuesCushingV2>
              full={true}
              name={'complicationsOfSurgicalProceduresCheck'}
              elements={complicationsOfSurgicalProceduresCheckboxesConfig}
              onChange={handleChangeCheckboxes}
              values={formik.values.complicationsOfSurgicalProceduresCheck}
            />
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset legend={'Przetrwała hiperkortyzolemia'}>
        <Grid container mt={1}>
          <Grid item xs={12} mb={2} mt={2}>
            <FormControlLabel
              onChange={formik.handleChange}
              control={
                <Checkbox
                  name={'pasireotideLar4WeeksCheckbox'}
                  checked={formik.values.pasireotideLar4WeeksCheckbox}
                  onChange={e => {
                    formik.handleChange(e);
                    if (!e.target.checked) {
                      formik.setFieldValue('pasireotideLar4WeeksDose', '');
                      formik.setFieldValue('pasireotideLar4WeeksDateStart', '');
                      formik.setFieldValue('pasireotideLar4WeeksDateEnd', '');
                      formik.setFieldValue('pasireotideLar4WeeksBiochemicalNormalization', '');
                      formik.setFieldValue('pasireotideLar4WeeksCortisolDzmisActive', false);
                      formik.setFieldValue('pasireotideLar4WeeksCortisolDzm', '');
                      formik.setFieldValue('pasireotideLar4WeeksCortisolSalivaisActive', false);
                      formik.setFieldValue('pasireotideLar4WeeksCortisolSaliva', '');
                      formik.setFieldValue('pasireotideLar4WeeksCortisolSerumisActive', false);
                      formik.setFieldValue('pasireotideLar4WeeksCortisolSerum', '');
                      formik.setFieldValue('pasireotideLar4WeeksToleranceOfPharmacologicalTreatment', []);
                      formik.setFieldValue('pasireotideLar4WeeksAnotherComplications', []);
                      formik.setFieldValue('pasireotideLar4WeeksReasonStopTreatment', '');
                      formik.setFieldValue('pasireotideLar4WeeksAnotherComplicationsAnother', '');
                      formik.setFieldValue('pasireotideLar4WeeksAnotherComplicationsAnotherCheckbox', false);
                    }
                  }}
                />
              }
              label="pazyreotyd LAR co 4 tygodnie"
            />
          </Grid>
          <Grid item xs={3.6} pr={1} mt={1}>
            <SelectCustom
              disabled={!formik.values.pasireotideLar4WeeksCheckbox}
              name={'pasireotideLar4WeeksDose'}
              required={false}
              placeholder={'dawka (mg)'}
              label={'Dawka (mg)'}
              onChange={formik.handleChange}
              value={formik.values.pasireotideLar4WeeksDose}
              options={treatmentBeforeOperationPasireotidesDoseOptions}
            />
          </Grid>
          <Grid item xs={3.6} pr={1} mt={1}>
            <DateInput
              disabled={!formik.values.pasireotideLar4WeeksCheckbox}
              label={'okres - OD'}
              required={false}
              views={['year', 'month']}
              openTo={'year'}
              name={'pasireotideLar4WeeksDateStart'}
              inputFormat={'mm.yyyy'}
              value={formik.values.pasireotideLar4WeeksDateStart}
              onBlur={() => formik.setFieldTouched('pasireotideLar4WeeksDateStart', true)}
              onChange={e => formik.setFieldValue('pasireotideLar4WeeksDateStart', e)}
            />
          </Grid>
          <Grid item xs={3.6} mt={1}>
            <DateInput
              disabled={!formik.values.pasireotideLar4WeeksCheckbox}
              label={'okres - DO'}
              isStill={true}
              required={false}
              views={['year', 'month']}
              openTo={'year'}
              name={'pasireotideLar4WeeksDateEnd'}
              error={Boolean(formik.errors.pasireotideLar4WeeksDateEnd)}
              inputFormat={'mm.yyyy'}
              value={formik.values.pasireotideLar4WeeksDateEnd}
              onBlur={() => formik.setFieldTouched('pasireotideLar4WeeksDateEnd', true)}
              onChange={e => formik.setFieldValue('pasireotideLar4WeeksDateEnd', e)}
            />
          </Grid>
          {formik.values.pasireotideLar4WeeksCheckbox && (
            <>
              <Grid container mt={3}>
                <Label>Uzyskano normalizację biochemiczną</Label>
                <Grid
                  item
                  xs={12}
                  mb={1}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'flex-start'}
                  justifyContent={'flex-start'}
                >
                  <RadioGroupStyled
                    row={true}
                    name={'pasireotideLar4WeeksBiochemicalNormalization'}
                    value={formik.values.pasireotideLar4WeeksBiochemicalNormalization}
                  >
                    <FormControlLabel
                      onChange={formik.handleChange}
                      value={'Tak'}
                      control={
                        <Radio
                          onClick={() =>
                            formik.setFieldValue(
                              'pasireotideLar4WeeksBiochemicalNormalization',
                              radioValueOptional(formik.values.pasireotideLar4WeeksBiochemicalNormalization, 'Tak')
                            )
                          }
                        />
                      }
                      label="Tak"
                    />
                    <FormControlLabel
                      onChange={formik.handleChange}
                      value={'Nie'}
                      control={
                        <Radio
                          onClick={async () => {
                            formik.setFieldValue(
                              'pasireotideLar4WeeksBiochemicalNormalization',
                              radioValueOptional(formik.values.pasireotideLar4WeeksBiochemicalNormalization, 'Nie')
                            );
                          }}
                        />
                      }
                      label="Nie"
                    />
                  </RadioGroupStyled>
                </Grid>
                {formik.values.pasireotideLar4WeeksBiochemicalNormalization === 'Tak' && (
                  <>
                    <Grid
                      item
                      xs={12}
                      pr={1}
                      mt={1}
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'flex-start'}
                      justifyContent={'center'}
                    >
                      <InputController<IInputControllerThirdStage>
                        setActive={setActive}
                        active={formik.values.pasireotideLar4WeeksCortisolDzmisActive}
                        setField={formik.setFieldValue}
                        inputName={['pasireotideLar4WeeksCortisolDzm']}
                        checkbox={{
                          // active: formik.values.pasireotideLar4WeeksCortisolDzmisActive,
                          //isActive: formik.values.pasireotideLar4WeeksCortisolDzmisActive,
                          name: 'pasireotideLar4WeeksCortisolDzmisActive',
                          label: 'wolnego kortyzolu w DZM'
                        }}
                      >
                        <Grid item xs={4} pr={1}>
                          <DateInput
                            disabled={!inputControllerElements.pasireotideLar4WeeksCortisolDzm}
                            label={'OD'}
                            required={false}
                            views={['year', 'month']}
                            openTo={'year'}
                            name={'pasireotideLar4WeeksCortisolDzm'}
                            inputFormat={'mm.yyyy'}
                            value={formik.values.pasireotideLar4WeeksCortisolDzm}
                            error={
                              formik.touched.pasireotideLar4WeeksCortisolDzm &&
                              Boolean(formik.errors.pasireotideLar4WeeksCortisolDzm)
                            }
                            onBlur={() => formik.setFieldTouched('pasireotideLar4WeeksCortisolDzm', true)}
                            onChange={e => formik.setFieldValue('pasireotideLar4WeeksCortisolDzm', e)}
                          />
                        </Grid>
                      </InputController>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      pr={1}
                      mt={2}
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'flex-start'}
                      justifyContent={'center'}
                    >
                      <InputController<IInputControllerThirdStage>
                        setActive={setActive}
                        active={formik.values.pasireotideLar4WeeksCortisolSalivaisActive}
                        setField={formik.setFieldValue}
                        inputName={['pasireotideLar4WeeksCortisolSaliva']}
                        checkbox={{
                          name: 'pasireotideLar4WeeksCortisolSalivaisActive',
                          label: 'wolnego kortyzolu w ślinie'
                        }}
                      >
                        <Grid item xs={4} pr={1}>
                          <DateInput
                            disabled={!inputControllerElements.pasireotideLar4WeeksCortisolSaliva}
                            label={'OD'}
                            required={false}
                            views={['year', 'month']}
                            openTo={'year'}
                            name={'pasireotideLar4WeeksCortisolSaliva'}
                            inputFormat={'mm.yyyy'}
                            value={formik.values.pasireotideLar4WeeksCortisolSaliva}
                            error={
                              formik.touched.pasireotideLar4WeeksCortisolSaliva &&
                              Boolean(formik.errors.pasireotideLar4WeeksCortisolSaliva)
                            }
                            onBlur={() => formik.setFieldTouched('pasireotideLar4WeeksCortisolSaliva', true)}
                            onChange={e => formik.setFieldValue('pasireotideLar4WeeksCortisolSaliva', e)}
                          />
                        </Grid>
                      </InputController>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      pr={1}
                      mt={2}
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'flex-start'}
                      justifyContent={'center'}
                    >
                      <InputController<IInputControllerThirdStage>
                        setActive={setActive}
                        active={formik.values.pasireotideLar4WeeksCortisolSerumisActive}
                        setField={formik.setFieldValue}
                        inputName={['pasireotideLar4WeeksCortisolSerum']}
                        checkbox={{
                          name: 'pasireotideLar4WeeksCortisolSerumisActive',
                          label: 'kortyzolu w surowicy'
                        }}
                      >
                        <Grid item xs={4} pr={1}>
                          <DateInput
                            disabled={!inputControllerElements.pasireotideLar4WeeksCortisolSerum}
                            label={'OD'}
                            required={false}
                            views={['year', 'month']}
                            openTo={'year'}
                            name={'pasireotideLar4WeeksCortisolSerum'}
                            inputFormat={'mm.yyyy'}
                            value={formik.values.pasireotideLar4WeeksCortisolSerum}
                            error={
                              formik.touched.pasireotideLar4WeeksCortisolSerum &&
                              Boolean(formik.errors.pasireotideLar4WeeksCortisolSerum)
                            }
                            onBlur={() => formik.setFieldTouched('pasireotideLar4WeeksCortisolSerum', true)}
                            onChange={e => formik.setFieldValue('pasireotideLar4WeeksCortisolSerum', e)}
                          />
                        </Grid>
                      </InputController>
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid container mt={1}>
                <Label>Tolerancja stosowanego leczenia farmakologicznego:</Label>
                <CheckboxesGroup<IThirdStageValuesCushingV2>
                  mt={2}
                  full={true}
                  name={'pasireotideLar4WeeksToleranceOfPharmacologicalTreatment'}
                  elements={tolerationCheckboxesConfig}
                  onChange={handleChangeCheckboxes}
                  values={formik.values.pasireotideLar4WeeksToleranceOfPharmacologicalTreatment}
                />
              </Grid>
              <Grid item xs={12} mt={3}>
                <Label>Inne powikłania</Label>
              </Grid>
              <Grid container mt={1}>
                <CheckboxesGroup<IThirdStageValuesCushingV2>
                  mt={1}
                  full={true}
                  name={'pasireotideLar4WeeksAnotherComplications'}
                  elements={otherComplicationsCheckboxesConfig}
                  onChange={handleChangeCheckboxes}
                  values={formik.values.pasireotideLar4WeeksAnotherComplications}
                />
                <InputController<IInputControllerThirdStage>
                  setActive={setActive}
                  active={inputControllerElements.pasireotideLar4WeeksAnotherComplicationsAnother}
                  setField={formik.setFieldValue}
                  inputName={'pasireotideLar4WeeksAnotherComplicationsAnother'}
                  checkbox={{
                    isActive: formik.values.pasireotideLar4WeeksAnotherComplicationsAnotherCheckbox,
                    name: 'pasireotideLar4WeeksAnotherComplicationsAnotherCheckbox',
                    label: 'inne (jakie?)'
                  }}
                >
                  <Input
                    InputLabelProps={{ shrink: true }}
                    disabled={!inputControllerElements.pasireotideLar4WeeksAnotherComplicationsAnother}
                    name={'pasireotideLar4WeeksAnotherComplicationsAnother'}
                    type={'text'}
                    onChange={formik.handleChange}
                    value={formik.values.pasireotideLar4WeeksAnotherComplicationsAnother}
                    label={'Wpisz jakie inne powikłania'}
                  />
                </InputController>
                <Grid item xs={12} mt={1}>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    name={'pasireotideLar4WeeksReasonStopTreatment'}
                    type={'text'}
                    multiline
                    rows={5}
                    onChange={formik.handleChange}
                    value={formik.values.pasireotideLar4WeeksReasonStopTreatment}
                    label={'Powód przerwania leczenia (jeśli dotyczy)'}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
        <Divider margin={32} />
        <Grid container>
          <Grid item xs={12} mb={2}>
            <FormControlLabel
              control={
                <Checkbox
                  name={'cabergolineCheckbox'}
                  checked={formik.values.cabergolineCheckbox}
                  onChange={e => {
                    formik.handleChange(e);
                    if (!e.target.checked) {
                      formik.setFieldValue('cabergolineDose', '');
                      formik.setFieldValue('cabergolineDateStart', '');
                      formik.setFieldValue('cabergolineDateEnd', '');
                      formik.setFieldValue('cabergolineBiochemicalNormalization', '');
                      formik.setFieldValue('cabergolineCortisolDzmisActive', false);
                      formik.setFieldValue('cabergolineCortisolDzm', '');
                      formik.setFieldValue('cabergolineCortisolSalivaisActive', false);
                      formik.setFieldValue('cabergolineCortisolSaliva', '');
                      formik.setFieldValue('cabergolineCortisolSerumisActive', false);
                      formik.setFieldValue('cabergolineCortisolSerum', '');
                      formik.setFieldValue('cabergolineToleranceOfPharmacologicalTreatment', []);
                      formik.setFieldValue('cabergolineAnotherComplications', []);
                      formik.setFieldValue('cabergolineReasonStopTreatment', '');
                      formik.setFieldValue('cabergolineAnotherComplicationsAnother', '');
                      formik.setFieldValue('cabergolineAnotherComplicationsAnotherCheckbox', false);
                    }
                  }}
                />
              }
              label="kabergolina"
            />
          </Grid>
          <Grid item xs={3.6} pr={1} mt={1}>
            <Input
              InputLabelProps={{ shrink: true }}
              name="cabergolineDose"
              disabled={!formik.values.cabergolineCheckbox}
              type={'number'}
              onChange={formik.handleChange}
              value={checkEmptyNumber(formik.values.cabergolineDose)}
              label={'Dawka (mg/tydzień)'}
            />
          </Grid>
          <Grid item xs={3.6} pr={1} mt={1}>
            <DateInput
              disabled={!formik.values.cabergolineCheckbox}
              label={'okres - OD'}
              required={false}
              views={['year', 'month']}
              openTo={'year'}
              name={'cabergolineDateStart'}
              inputFormat={'mm.yyyy'}
              value={formik.values.cabergolineDateStart}
              onBlur={() => formik.setFieldTouched('cabergolineDateStart', true)}
              onChange={e => formik.setFieldValue('cabergolineDateStart', e)}
            />
          </Grid>
          <Grid item xs={3.6} mt={1}>
            <DateInput
              disabled={!formik.values.cabergolineCheckbox}
              label={'okres - DO'}
              isStill={true}
              required={false}
              views={['year', 'month']}
              openTo={'year'}
              name={'cabergolineDateEnd'}
              error={Boolean(formik.errors.cabergolineDateEnd)}
              inputFormat={'mm.yyyy'}
              value={formik.values.cabergolineDateEnd}
              onBlur={() => formik.setFieldTouched('cabergolineDateEnd', true)}
              onChange={e => formik.setFieldValue('cabergolineDateEnd', e)}
            />
          </Grid>
          {formik.values.cabergolineCheckbox && (
            <>
              <Grid container mt={3}>
                <Label>Uzyskano normalizację biochemiczną</Label>
                <Grid
                  item
                  xs={12}
                  mb={1}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'flex-start'}
                  justifyContent={'flex-start'}
                >
                  <RadioGroupStyled
                    row={true}
                    name={'cabergolineBiochemicalNormalization'}
                    value={formik.values.cabergolineBiochemicalNormalization}
                  >
                    <FormControlLabel
                      onChange={formik.handleChange}
                      value={'Tak'}
                      control={
                        <Radio
                          onClick={() =>
                            formik.setFieldValue(
                              'cabergolineBiochemicalNormalization',
                              radioValueOptional(formik.values.cabergolineBiochemicalNormalization, 'Tak')
                            )
                          }
                        />
                      }
                      label="Tak"
                    />
                    <FormControlLabel
                      onChange={formik.handleChange}
                      value={'Nie'}
                      control={
                        <Radio
                          onClick={() =>
                            formik.setFieldValue(
                              'cabergolineBiochemicalNormalization',
                              radioValueOptional(formik.values.cabergolineBiochemicalNormalization, 'Nie')
                            )
                          }
                        />
                      }
                      label="Nie"
                    />
                  </RadioGroupStyled>
                </Grid>
                {formik.values.cabergolineBiochemicalNormalization === 'Tak' && (
                  <>
                    <Grid
                      item
                      xs={12}
                      pr={1}
                      mt={1}
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'flex-start'}
                      justifyContent={'center'}
                    >
                      <InputController<IInputControllerThirdStage>
                        setActive={setActive}
                        active={formik.values.cabergolineCortisolDzmisActive}
                        setField={formik.setFieldValue}
                        clearFields={() => {
                          formik.setFieldValue('cabergolineCortisolDzm', null);
                        }}
                        inputName={['cabergolineCortisolDzm']}
                        checkbox={{
                          name: 'cabergolineCortisolDzmisActive',
                          label: 'wolnego kortyzolu w DZM'
                        }}
                      >
                        <Grid item xs={4} pr={1}>
                          <DateInput
                            disabled={!inputControllerElements.cabergolineCortisolDzm}
                            label={'OD'}
                            required={false}
                            views={['year', 'month']}
                            openTo={'year'}
                            name={'cabergolineCortisolDzm'}
                            inputFormat={'mm.yyyy'}
                            value={formik.values.cabergolineCortisolDzm}
                            error={
                              formik.touched.cabergolineCortisolDzm && Boolean(formik.errors.cabergolineCortisolDzm)
                            }
                            onBlur={() => formik.setFieldTouched('cabergolineCortisolDzm', true)}
                            onChange={e => formik.setFieldValue('cabergolineCortisolDzm', e)}
                          />
                        </Grid>
                      </InputController>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      pr={1}
                      mt={2}
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'flex-start'}
                      justifyContent={'center'}
                    >
                      <InputController<IInputControllerThirdStage>
                        setActive={setActive}
                        active={formik.values.cabergolineCortisolSalivaisActive}
                        setField={formik.setFieldValue}
                        inputName={['cabergolineCortisolSaliva']}
                        checkbox={{
                          name: 'cabergolineCortisolSalivaisActive',
                          label: 'wolnego kortyzolu w ślinie'
                        }}
                      >
                        <Grid item xs={4} pr={1}>
                          <DateInput
                            disabled={!inputControllerElements.cabergolineCortisolSaliva}
                            label={'OD'}
                            required={false}
                            views={['year', 'month']}
                            openTo={'year'}
                            name={'cabergolineCortisolSaliva'}
                            inputFormat={'mm.yyyy'}
                            value={formik.values.cabergolineCortisolSaliva}
                            error={
                              formik.touched.cabergolineCortisolSaliva &&
                              Boolean(formik.errors.cabergolineCortisolSaliva)
                            }
                            onBlur={() => formik.setFieldTouched('cabergolineCortisolSaliva', true)}
                            onChange={e => formik.setFieldValue('cabergolineCortisolSaliva', e)}
                          />
                        </Grid>
                      </InputController>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      pr={1}
                      mt={2}
                      display={'flex'}
                      flexDirection={'column'}
                      alignItems={'flex-start'}
                      justifyContent={'center'}
                    >
                      <InputController<IInputControllerThirdStage>
                        setActive={setActive}
                        active={formik.values.cabergolineCortisolSerumisActive}
                        setField={formik.setFieldValue}
                        inputName={['cabergolineCortisolSerum']}
                        checkbox={{
                          name: 'cabergolineCortisolSerumisActive',
                          label: 'kortyzolu w surowicy'
                        }}
                      >
                        <Grid item xs={4} pr={1}>
                          <DateInput
                            disabled={!inputControllerElements.cabergolineCortisolSerum}
                            label={'OD'}
                            required={false}
                            views={['year', 'month']}
                            openTo={'year'}
                            name={'cabergolineCortisolSerum'}
                            inputFormat={'mm.yyyy'}
                            value={formik.values.cabergolineCortisolSerum}
                            error={
                              formik.touched.cabergolineCortisolSerum && Boolean(formik.errors.cabergolineCortisolSerum)
                            }
                            onBlur={() => formik.setFieldTouched('cabergolineCortisolSerum', true)}
                            onChange={e => formik.setFieldValue('cabergolineCortisolSerum', e)}
                          />
                        </Grid>
                      </InputController>
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid container mt={1}>
                <Label>Tolerancja stosowanego leczenia farmakologicznego:</Label>
                <CheckboxesGroup<IThirdStageValuesCushingV2>
                  mt={2}
                  full={true}
                  name={'cabergolineToleranceOfPharmacologicalTreatment'}
                  elements={tolerationCheckboxesConfig}
                  onChange={handleChangeCheckboxes}
                  values={formik.values.cabergolineToleranceOfPharmacologicalTreatment}
                />
              </Grid>
              <Grid item xs={12} mt={3}>
                <Label>Inne powikłania</Label>
              </Grid>
              <Grid container mt={1}>
                <CheckboxesGroup<IThirdStageValuesCushingV2>
                  mt={1}
                  full={true}
                  name={'cabergolineAnotherComplications'}
                  elements={otherComplicationsCheckboxesConfig}
                  onChange={handleChangeCheckboxes}
                  values={formik.values.cabergolineAnotherComplications}
                />
                <InputController<IInputControllerThirdStage>
                  setActive={setActive}
                  active={inputControllerElements.cabergolineAnotherComplicationsAnother}
                  setField={formik.setFieldValue}
                  inputName={'cabergolineAnotherComplicationsAnother'}
                  checkbox={{
                    name: 'cabergolineAnotherComplicationsAnotherCheckbox',
                    label: 'inne (jakie?)'
                  }}
                >
                  <Input
                    InputLabelProps={{ shrink: true }}
                    disabled={!inputControllerElements.cabergolineAnotherComplicationsAnother}
                    name={'cabergolineAnotherComplicationsAnother'}
                    type={'text'}
                    onChange={formik.handleChange}
                    value={formik.values.cabergolineAnotherComplicationsAnother}
                    label={'Wpisz jakie inne powikłania'}
                  />
                </InputController>
                <Grid item xs={12} mt={1}>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    name={'cabergolineReasonStopTreatment'}
                    type={'text'}
                    multiline
                    rows={5}
                    onChange={formik.handleChange}
                    value={formik.values.cabergolineReasonStopTreatment}
                    label={'Powód przerwania leczenia (jeśli dotyczy)'}
                  />
                </Grid>
              </Grid>
            </>
          )}
          <Divider margin={32} />
          <Grid item xs={12} mb={2} mt={2}>
            <FormControlLabel
              onChange={formik.handleChange}
              control={
                <Checkbox
                  name={'steroidogenesisInhibitorCheckbox'}
                  checked={formik.values.steroidogenesisInhibitorCheckbox}
                  onChange={e => {
                    formik.handleChange(e);
                    if (!e.target.checked) {
                      formik.setFieldValue('steroidogenesisInhibitorArray', []);
                      formik.setFieldValue('biochemicalNormalization', '');
                      formik.setFieldValue('steroidogenesisInhibitorDzmCheckbox', false);
                      formik.setFieldValue('steroidogenesisInhibitorDzmArray', []);
                      formik.setFieldValue('steroidogenesisInhibitorSalivaCheckbox', false);
                      formik.setFieldValue('steroidogenesisInhibitorSalivaArray', []);
                      formik.setFieldValue('steroidogenesisInhibitorSerumCheckbox', false);
                      formik.setFieldValue('steroidogenesisInhibitorSerumArray', []);
                      formik.setFieldValue('toleranceOfPharmacologicalTreatment', []);
                      formik.setFieldValue('anotherComplications', []);
                      formik.setFieldValue('anotherComplicationsAnother', '');
                      formik.setFieldValue('reasonStopTreatment', '');
                    }
                  }}
                />
              }
              label="inhibitor steroidogenezy"
            />
          </Grid>
          {formik.values.steroidogenesisInhibitorCheckbox && (
            <>
              {formik.values.steroidogenesisInhibitorArray?.map((el, index) => (
                <Grid container key={`inhibitor-${index}`}>
                  <Grid item xs={12} display="flex" alignItems={'center'} gap={2}>
                    <span>{index + 1}</span>
                    <Label>Inhibitor:</Label>
                    <RadioGroupStyled
                      row={true}
                      name={`steroidogenesisInhibitorArray[${index}].type`}
                      value={formik.values.steroidogenesisInhibitorArray[index].type}
                    >
                      <FormControlLabel
                        onChange={formik.handleChange}
                        value={'Osilodrostat'}
                        control={<Radio />}
                        label="Osilodrostat"
                      />
                      <FormControlLabel
                        onChange={formik.handleChange}
                        value={'Metyrapon'}
                        control={<Radio />}
                        label="Metyrapon"
                      />
                      <FormControlLabel
                        onChange={formik.handleChange}
                        value={'Inny'}
                        control={<Radio />}
                        label="Inny"
                      />
                    </RadioGroupStyled>
                    <CloseIcon
                      sx={{ cursor: 'pointer' }}
                      color={'primary'}
                      onClick={() => handleDeleteSteroidogenesisInhibitorArray(index)}
                    />
                  </Grid>
                  {(formik.values.steroidogenesisInhibitorArray[index].type === 'Metyrapon' ||
                    formik.values.steroidogenesisInhibitorArray[index].type === 'Osilodrostat') && (
                    <Grid container mb={2}>
                      <Grid item xs={6} pr={1}>
                        <Input
                          InputLabelProps={{ shrink: true }}
                          name={`steroidogenesisInhibitorArray[${index}].dose`}
                          type={'number'}
                          onChange={formik.handleChange}
                          value={checkEmptyNumber(formik.values.steroidogenesisInhibitorArray[index].dose as number)}
                          label={'Dawka'}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          InputLabelProps={{ shrink: true }}
                          name={`steroidogenesisInhibitorArray[${index}].frequency`}
                          type={'text'}
                          onChange={formik.handleChange}
                          value={
                            (formik.values.steroidogenesisInhibitorArray as ISteroidogenesisInhibitor[])[index]
                              .frequency
                          }
                          label={'Ile razy na dobę'}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        pr={1}
                        mt={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <Input
                          InputLabelProps={{ shrink: true }}
                          name={`steroidogenesisInhibitorArray[${index}].doseEscalation`}
                          type={'text'}
                          multiline={true}
                          rows={3}
                          onChange={formik.handleChange}
                          value={
                            (formik.values.steroidogenesisInhibitorArray as ISteroidogenesisInhibitor[])[index]
                              .doseEscalation as string
                          }
                          label={'W jaki sposób eskalowano dawkę?'}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3.5}
                        pr={1}
                        mt={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <Input
                          InputLabelProps={{ shrink: true }}
                          name={`steroidogenesisInhibitorArray[${index}].maxDose`}
                          type={'number'}
                          onChange={formik.handleChange}
                          value={checkEmptyNumber(
                            (formik.values.steroidogenesisInhibitorArray as ISteroidogenesisInhibitor[])[index]
                              .maxDose as number
                          )}
                          label={'Dawka maksymalna'}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3.5}
                        pr={1}
                        mt={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <Input
                          InputLabelProps={{ shrink: true }}
                          name={`steroidogenesisInhibitorArray[${index}].maintenanceDose`}
                          type={'number'}
                          onChange={formik.handleChange}
                          value={checkEmptyNumber(
                            (formik.values.steroidogenesisInhibitorArray as ISteroidogenesisInhibitor[])[index]
                              .maintenanceDose as number
                          )}
                          label={'Dawka podtrzymująca'}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={2.5}
                        pr={1}
                        mt={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <DateInput
                          label={'okres - OD'}
                          required={false}
                          views={['year', 'month']}
                          openTo={'year'}
                          name={`steroidogenesisInhibitorArray[${index}].dateStart`}
                          inputFormat={'mm.yyyy'}
                          value={formik.values.steroidogenesisInhibitorArray[index].dateStart}
                          onBlur={() =>
                            formik.setFieldTouched(`steroidogenesisInhibitorArray[${index}].dateStart`, true)
                          }
                          onChange={e => formik.setFieldValue(`steroidogenesisInhibitorArray[${index}].dateStart`, e)}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={2.5}
                        pr={1}
                        mt={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <DateInput
                          label={'okres - DO'}
                          required={false}
                          isStill={true}
                          views={['year', 'month']}
                          openTo={'year'}
                          name={`steroidogenesisInhibitorArray[${index}].dateEnd`}
                          inputFormat={'mm.yyyy'}
                          error={
                            Array.isArray(formik.touched.steroidogenesisInhibitorArray) &&
                            formik.touched.steroidogenesisInhibitorArray[index]?.dateEnd &&
                            Array.isArray(formik.errors.steroidogenesisInhibitorArray) &&
                            Boolean(
                              (
                                formik.errors.steroidogenesisInhibitorArray[
                                  index
                                ] as FormikErrors<ISteroidogenesisInhibitor>
                              )?.dateEnd
                            )
                          }
                          value={formik.values.steroidogenesisInhibitorArray[index].dateEnd}
                          onBlur={() => formik.setFieldTouched(`steroidogenesisInhibitorArray[${index}].dateEnd`, true)}
                          onChange={e => formik.setFieldValue(`steroidogenesisInhibitorArray[${index}].dateEnd`, e)}
                        />
                      </Grid>
                    </Grid>
                  )}
                  {formik.values.steroidogenesisInhibitorArray[index].type === 'Inny' && (
                    <>
                      <Grid
                        item
                        xs={3}
                        pr={1}
                        mb={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <Input
                          InputLabelProps={{ shrink: true }}
                          name={`steroidogenesisInhibitorArray[${index}].name`}
                          type={'text'}
                          onChange={formik.handleChange}
                          value={
                            (formik.values.steroidogenesisInhibitorArray as ISteroidogenesisInhibitor[])[index]
                              .name as string
                          }
                          label={'Nazwa'}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        pr={1}
                        mb={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <Input
                          InputLabelProps={{ shrink: true }}
                          name={`steroidogenesisInhibitorArray[${index}].dose`}
                          type={'number'}
                          onChange={formik.handleChange}
                          value={checkEmptyNumber(
                            (formik.values.steroidogenesisInhibitorArray as ISteroidogenesisInhibitor[])[index]
                              .dose as number
                          )}
                          label={'Dawka'}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        pr={1}
                        mb={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <DateInput
                          label={'okres - OD'}
                          required={false}
                          views={['year', 'month']}
                          openTo={'year'}
                          name={`steroidogenesisInhibitorArray[${index}].dateStart`}
                          inputFormat={'mm.yyyy'}
                          value={formik.values.steroidogenesisInhibitorArray[index].dateStart}
                          onBlur={() =>
                            formik.setFieldTouched(`steroidogenesisInhibitorArray[${index}].dateStart`, true)
                          }
                          onChange={e => formik.setFieldValue(`steroidogenesisInhibitorArray[${index}].dateStart`, e)}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        pr={1}
                        mb={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        justifyContent={'center'}
                      >
                        <DateInput
                          label={'okres - DO'}
                          required={false}
                          isStill={true}
                          views={['year', 'month']}
                          openTo={'year'}
                          name={`steroidogenesisInhibitorArray[${index}].dateEnd`}
                          inputFormat={'mm.yyyy'}
                          error={
                            Array.isArray(formik.touched.steroidogenesisInhibitorArray) &&
                            formik.touched.steroidogenesisInhibitorArray[index]?.dateEnd &&
                            Array.isArray(formik.errors.steroidogenesisInhibitorArray) &&
                            Boolean(
                              (
                                formik.errors.steroidogenesisInhibitorArray[
                                  index
                                ] as FormikErrors<ISteroidogenesisInhibitor>
                              )?.dateEnd
                            )
                          }
                          value={formik.values.steroidogenesisInhibitorArray[index].dateEnd}
                          onBlur={() => formik.setFieldTouched(`steroidogenesisInhibitorArray[${index}].dateEnd`, true)}
                          onChange={e => formik.setFieldValue(`steroidogenesisInhibitorArray[${index}].dateEnd`, e)}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              ))}
            </>
          )}
          <Grid item xs={12}>
            <Button
              disabled={!formik.values.steroidogenesisInhibitorCheckbox}
              startIcon={<Add />}
              variant="contained"
              color={'primary'}
              onClick={handleAddSteroidogenesisInhibitorArray}
            >
              DODAJ
            </Button>
          </Grid>
        </Grid>
      </Fieldset>
      {formik.values.steroidogenesisInhibitorCheckbox && (
        <>
          <Grid container mt={3}>
            <Label>Uzyskano normalizację biochemiczną:</Label>
            <Grid
              item
              xs={12}
              mb={1}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'flex-start'}
              justifyContent={'flex-start'}
            >
              <RadioGroupStyled
                row={true}
                name={'biochemicalNormalization'}
                value={formik.values.biochemicalNormalization}
              >
                <FormControlLabel
                  onChange={formik.handleChange}
                  value={'Tak'}
                  control={
                    <Radio
                      onClick={() =>
                        formik.setFieldValue(
                          'biochemicalNormalization',
                          radioValueOptional(formik.values.biochemicalNormalization, 'Tak')
                        )
                      }
                    />
                  }
                  label="Tak"
                />
                <FormControlLabel
                  onChange={formik.handleChange}
                  value={'Nie'}
                  control={
                    <Radio
                      onClick={() =>
                        formik.setFieldValue(
                          'biochemicalNormalization',
                          radioValueOptional(formik.values.biochemicalNormalization, 'Nie')
                        )
                      }
                    />
                  }
                  label="Nie"
                />
              </RadioGroupStyled>
            </Grid>
            <Grid container mt={1}>
              <Grid item xs={12}>
                <Typography variant={'caption'} mt={1} color={'#ED6C02'}>
                  Proszę dodać jak najwięcej badań, dane te zostaną wykorzystane do wykonania wykresu
                </Typography>
              </Grid>
              <Grid item xs={12} mb={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={'steroidogenesisInhibitorDzmCheckbox'}
                      checked={formik.values.steroidogenesisInhibitorDzmCheckbox}
                      onChange={formik.handleChange}
                    />
                  }
                  label="wolnego kortyzolu w DZM"
                />
              </Grid>
              {formik.values.steroidogenesisInhibitorDzmArray?.map((el, index) => (
                <Grid container key={`dzm-${index}`} mb={2} alignItems={'center'}>
                  <Grid item pr={1}>
                    {index + 1}
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <DateInput
                      label={'Data badania'}
                      required={false}
                      views={['year', 'month']}
                      openTo={'year'}
                      name={`steroidogenesisInhibitorDzmArray[${index}].date`}
                      inputFormat={'mm.yyyy'}
                      value={formik.values.steroidogenesisInhibitorDzmArray[index].date}
                      error={
                        Array.isArray(formik.touched.steroidogenesisInhibitorDzmArray) &&
                        formik.touched.steroidogenesisInhibitorDzmArray[index]?.date &&
                        Array.isArray(formik.errors.steroidogenesisInhibitorDzmArray) &&
                        Boolean(
                          (
                            formik.errors.steroidogenesisInhibitorDzmArray[
                              index
                            ] as FormikErrors<ISteroidogenesisInhibitorCortisol>
                          )?.date
                        )
                      }
                      onBlur={() => formik.setFieldTouched(`steroidogenesisInhibitorDzmArray[${index}].date`, true)}
                      onChange={e => formik.setFieldValue(`steroidogenesisInhibitorDzmArray[${index}].date`, e)}
                    />
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      name={`steroidogenesisInhibitorDzmArray[${index}].cortisol`}
                      type={'number'}
                      onChange={formik.handleChange}
                      value={checkEmptyNumber(formik.values.steroidogenesisInhibitorDzmArray[index].cortisol as number)}
                      label={'Poziom kortyzolu'}
                    />
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      name={`steroidogenesisInhibitorDzmArray[${index}].dose`}
                      type={'number'}
                      onChange={formik.handleChange}
                      value={checkEmptyNumber(formik.values.steroidogenesisInhibitorDzmArray[index].dose as number)}
                      label={'Dawka'}
                    />
                  </Grid>
                  <CloseIcon
                    sx={{ cursor: 'pointer' }}
                    color={'primary'}
                    onClick={() => handleDeleteSteroidogenesisInhibitorDzm(index)}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Button
                  disabled={!formik.values.steroidogenesisInhibitorDzmCheckbox}
                  startIcon={<Add />}
                  variant="contained"
                  color={'primary'}
                  onClick={handleAddSteroidogenesisInhibitorDzm}
                >
                  DODAJ
                </Button>
              </Grid>
              <Grid item xs={12} mb={2} mt={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={'steroidogenesisInhibitorSalivaCheckbox'}
                      checked={formik.values.steroidogenesisInhibitorSalivaCheckbox}
                      onChange={formik.handleChange}
                    />
                  }
                  label="wolnego kortyzolu w ślinie"
                />
              </Grid>
              {formik.values.steroidogenesisInhibitorSalivaArray?.map((el, index) => (
                <Grid container key={`saliva-${index}`} mb={2} alignItems={'center'}>
                  <Grid item pr={1}>
                    {index + 1}
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <DateInput
                      label={'Data badania'}
                      required={false}
                      views={['year', 'month']}
                      openTo={'year'}
                      name={`steroidogenesisInhibitorSalivaArray[${index}].date`}
                      inputFormat={'mm.yyyy'}
                      value={formik.values.steroidogenesisInhibitorSalivaArray[index].date}
                      error={
                        Array.isArray(formik.touched.steroidogenesisInhibitorSalivaArray) &&
                        formik.touched.steroidogenesisInhibitorSalivaArray[index]?.date &&
                        Array.isArray(formik.errors.steroidogenesisInhibitorSalivaArray) &&
                        Boolean(
                          (
                            formik.errors.steroidogenesisInhibitorSalivaArray[
                              index
                            ] as FormikErrors<ISteroidogenesisInhibitorCortisol>
                          )?.date
                        )
                      }
                      onBlur={() => formik.setFieldTouched(`steroidogenesisInhibitorSalivaArray[${index}].date`, true)}
                      onChange={e => formik.setFieldValue(`steroidogenesisInhibitorSalivaArray[${index}].date`, e)}
                    />
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      name={`steroidogenesisInhibitorSalivaArray[${index}].cortisol`}
                      type={'number'}
                      onChange={formik.handleChange}
                      value={checkEmptyNumber(
                        formik.values.steroidogenesisInhibitorSalivaArray[index].cortisol as number
                      )}
                      label={'Poziom kortyzolu'}
                    />
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      name={`steroidogenesisInhibitorSalivaArray[${index}].dose`}
                      type={'number'}
                      onChange={formik.handleChange}
                      value={checkEmptyNumber(formik.values.steroidogenesisInhibitorSalivaArray[index].dose as number)}
                      label={'Dawka'}
                    />
                  </Grid>
                  <CloseIcon
                    sx={{ cursor: 'pointer' }}
                    color={'primary'}
                    onClick={() => handleDeleteSteroidogenesisInhibitorSaliva(index)}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Button
                  disabled={!formik.values.steroidogenesisInhibitorSalivaCheckbox}
                  startIcon={<Add />}
                  variant="contained"
                  color={'primary'}
                  onClick={handleAddSteroidogenesisInhibitorSaliva}
                >
                  DODAJ
                </Button>
              </Grid>
              <Grid item xs={12} mb={2} mt={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={'steroidogenesisInhibitorSerumCheckbox'}
                      checked={formik.values.steroidogenesisInhibitorSerumCheckbox}
                      onChange={formik.handleChange}
                    />
                  }
                  label="kortyzolu w surowicy"
                />
              </Grid>
              {formik.values.steroidogenesisInhibitorSerumArray?.map((el, index) => (
                <Grid container key={`serum-${index}`} mb={2} alignItems={'center'}>
                  <Grid item pr={1}>
                    {index + 1}
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <DateInput
                      label={'Data badania'}
                      required={false}
                      views={['year', 'month']}
                      openTo={'year'}
                      name={`steroidogenesisInhibitorSerumArray[${index}].date`}
                      inputFormat={'mm.yyyy'}
                      value={formik.values.steroidogenesisInhibitorSerumArray[index].date}
                      error={
                        Array.isArray(formik.touched.steroidogenesisInhibitorSerumArray) &&
                        formik.touched.steroidogenesisInhibitorSerumArray[index]?.date &&
                        Array.isArray(formik.errors.steroidogenesisInhibitorSerumArray) &&
                        Boolean(
                          (
                            formik.errors.steroidogenesisInhibitorSerumArray[
                              index
                            ] as FormikErrors<ISteroidogenesisInhibitorCortisol>
                          )?.date
                        )
                      }
                      onBlur={() => formik.setFieldTouched(`steroidogenesisInhibitorSerumArray[${index}].date`, true)}
                      onChange={e => formik.setFieldValue(`steroidogenesisInhibitorSerumArray[${index}].date`, e)}
                    />
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      name={`steroidogenesisInhibitorSerumArray[${index}].cortisol`}
                      type={'number'}
                      onChange={formik.handleChange}
                      value={checkEmptyNumber(
                        formik.values.steroidogenesisInhibitorSerumArray[index].cortisol as number
                      )}
                      label={'Poziom kortyzolu'}
                    />
                  </Grid>
                  <Grid item xs={3} pr={1}>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      name={`steroidogenesisInhibitorSerumArray[${index}].dose`}
                      type={'number'}
                      onChange={formik.handleChange}
                      value={checkEmptyNumber(formik.values.steroidogenesisInhibitorSerumArray[index].dose as number)}
                      label={'Dawka'}
                    />
                  </Grid>
                  <CloseIcon
                    sx={{ cursor: 'pointer' }}
                    color={'primary'}
                    onClick={() => handleDeleteSteroidogenesisInhibitorSerum(index)}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Button
                  disabled={!formik.values.steroidogenesisInhibitorSerumCheckbox}
                  startIcon={<Add />}
                  variant="contained"
                  color={'primary'}
                  onClick={handleAddSteroidogenesisInhibitorSerum}
                >
                  DODAJ
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid>
            <Grid container mt={2}>
              <Grid item xs={12}>
                <Label>Tolerancja stosowanego leczenia farmakologicznego:</Label>
              </Grid>
              <Grid item xs={12} pr={1}>
                <CheckboxesGroup<IThirdStageValuesCushingV2>
                  mt={2}
                  full={true}
                  name={'toleranceOfPharmacologicalTreatment'}
                  elements={tolerationCheckboxesConfig}
                  onChange={handleChangeCheckboxes}
                  values={formik.values.toleranceOfPharmacologicalTreatment}
                />
              </Grid>
            </Grid>
            <Grid container mt={2}>
              <Label>Inne powikłania:</Label>
              <Grid container>
                <MultipleSelect
                  label={'Inne powikłania'}
                  elementName="anotherComplications"
                  selectedValues={formik.values.anotherComplications}
                  isError={Boolean(formik.errors.anotherComplications)}
                  handleChange={values => setOption(values as string[], 'anotherComplications')}
                  options={tolerationOptions}
                />
              </Grid>
              {formik.values.anotherComplications?.includes('Inne') && (
                <Grid item xs={12} mt={2}>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    name={'anotherComplicationsAnother'}
                    type={'text'}
                    onChange={formik.handleChange}
                    value={formik.values.anotherComplicationsAnother}
                    label={'Inne'}
                  />
                </Grid>
              )}
              <Grid item xs={12} mt={2}>
                <Input
                  InputLabelProps={{ shrink: true }}
                  name={'reasonStopTreatment'}
                  type={'text'}
                  multiline
                  rows={5}
                  onChange={formik.handleChange}
                  value={formik.values.reasonStopTreatment}
                  label={'Powód przerwania leczenia (jeśli dotyczy)'}
                />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
      <Fieldset legend={'Kwalifikacja do'}>
        <Grid container mt={3}>
          <InputController<IInputControllerThirdStage>
            setActive={setActive}
            active={inputControllerElements.qualificationsDiagnosisAccess}
            setField={formik.setFieldValue}
            inputName={['qualificationsDiagnosisAccess']}
            checkbox={{
              name: 'qualificationsDiagnosisAccessCheckbox',
              label: 'ponownego leczenia neurochirurgicznego'
            }}
          >
            <SelectCustom
              disabled={!inputControllerElements.qualificationsDiagnosisAccess}
              error={Boolean(formik.errors.qualificationsDiagnosisAccess)}
              name={'qualificationsDiagnosisAccess'}
              placeholder={'z jakiego dostępu'}
              label={'Z jakiego dostępu'}
              onChange={formik.handleChange}
              value={formik.values.qualificationsDiagnosisAccess}
              options={neurosurgicalTreatmentOptions}
            />
          </InputController>
          <CheckboxesGroup<IThirdStageValuesCushingV2>
            mt={2}
            full={true}
            name={'qualificationsDiagnosis'}
            elements={qualificationCheckboxesConfig}
            onChange={handleChangeCheckboxes}
            values={formik.values.qualificationsDiagnosis}
          />
        </Grid>
      </Fieldset>
      <Fieldset legend={'Leczenie wspomagające chorób współistniejących i powikłań'}>
        <Grid container mt={2}>
          {formik.values.supprotiveTreatment.map((el, index) => (
            <Grid mb={2} item display={'flex'} xs={12} key={index} alignItems={'center'}>
              {index + 1}

              <Grid item xs={3} pl={2} pr={2}>
                <Input
                  InputLabelProps={{ shrink: true }}
                  fullWidth={true}
                  name={`supprotiveTreatment[${index}].group`}
                  label={'Grupa leków'}
                  type={'text'}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.supprotiveTreatment[index].group}
                  error={Boolean(formik.errors.supprotiveTreatment)}
                />
              </Grid>
              <Grid item xs={3} pr={2}>
                <Input
                  InputLabelProps={{ shrink: true }}
                  fullWidth={true}
                  name={`supprotiveTreatment[${index}].drug`}
                  label={'Lek'}
                  type={'text'}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.supprotiveTreatment[index].drug}
                  error={Boolean(formik.errors.supprotiveTreatment)}
                />
              </Grid>
              <Grid item xs={3} pr={2}>
                <Input
                  InputLabelProps={{ shrink: true }}
                  fullWidth={true}
                  name={`supprotiveTreatment[${index}].dose`}
                  label={'Dawka'}
                  type={'text'}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.supprotiveTreatment[index].dose}
                  error={Boolean(formik.errors.supprotiveTreatment)}
                />
              </Grid>
              <CloseIcon
                sx={{ cursor: 'pointer' }}
                color={'primary'}
                onClick={() => handleDeleteSupportTreatment(index)}
              />
            </Grid>
          ))}

          <Grid item xs={12} mt={2}>
            <Button startIcon={<Add />} variant="contained" color={'primary'} onClick={handleAddSupportTreatment}>
              DODAJ
            </Button>
          </Grid>
          <Divider margin={20} />
        </Grid>
      </Fieldset>
      <Fieldset legend={'Uzyskano poprawę w zakresie'} margin={'0px'}>
        <Grid container>
          <CheckboxesGroup<IThirdStageValuesCushingV2>
            mt={1}
            full={true}
            name={'improvementControl'}
            elements={supportTreatmentCheckboxesConfig}
            onChange={handleChangeCheckboxes}
            values={formik.values.improvementControl}
          />
        </Grid>
      </Fieldset>
      {isCushing && (
        <Grid item xs={12} display={'flex'} justifyContent={'flex-end'} mt={2}>
          <Typography variant="caption" color={'rgba(0,0,0,0.6)'}>
            PL-IST-0068
          </Typography>
        </Grid>
      )}
      <ButtonsActions handleDraftSave={handleDraftSave} handleSave={handleSave} />
    </Grid>
  );
});
